"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filter = function (args, condition) {
    return Array.prototype.filter.call(args, condition);
};
exports.map = function (args, mapper) {
    return Array.prototype.map.call(args, mapper);
};
